"use strict";

require("core-js/modules/es6.object.freeze");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Divider = _styledComponents["default"].hr.attrs(function (props) {
  return {
    bg: props.bg || 'lightGrey',
    border: 'none',
    height: '1px'
  };
})(_templateObject(), _styledSystem.alignContent, _styledSystem.alignItems, _styledSystem.alignSelf, _styledSystem.background, _styledSystem.backgroundColor, _styledSystem.backgroundImage, _styledSystem.backgroundPosition, _styledSystem.backgroundRepeat, _styledSystem.backgroundSize, _styledSystem.border, _styledSystem.borderColor, _styledSystem.boxShadow, _styledSystem.color, _styledSystem.display, _styledSystem.flex, _styledSystem.flexBasis, _styledSystem.flexDirection, _styledSystem.flexWrap, _styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.fontStyle, _styledSystem.fontWeight, _styledSystem.height, _styledSystem.justifyContent, _styledSystem.justifyItems, _styledSystem.justifySelf, _styledSystem.letterSpacing, _styledSystem.margin, _styledSystem.marginBottom, _styledSystem.marginLeft, _styledSystem.marginRight, _styledSystem.marginTop, _styledSystem.maxHeight, _styledSystem.maxWidth, _styledSystem.minHeight, _styledSystem.minWidth, _styledSystem.opacity, _styledSystem.overflow, _styledSystem.padding, _styledSystem.paddingBottom, _styledSystem.paddingLeft, _styledSystem.paddingRight, _styledSystem.paddingTop, _styledSystem.size, _styledSystem.space, _styledSystem.textAlign, _styledSystem.verticalAlign, _styledSystem.width, _styledSystem.zIndex);

exports.Divider = Divider;